export const getAccessToken = () => {
    if (typeof window === "undefined")
        return ''
    return localStorage.getItem('token') || '';
}
import toast from "react-hot-toast";

export const BASE_URL = process.env.REACT_APP_PP_API_BACKEND
const displayError = (message: any, shouldHide: any) => {
    !shouldHide && toast.error(message);
}

export const getRandomId = () => {
    if (typeof window === 'undefined') return '';
    return localStorage.getItem('randomId') || localStorage.getItem('uuid');
  };

  
export async function Client(
    endpoint: string,
    {body, ...customConfig} = {} as any
) {
    const headers: any = {
        'Content-Type': 'application/json',
        version: '0.0.1',
        'client-id': '5eb393ee95fab7468a79d189',
        'client-type': 'WEB',
        'client-version': 200,
        randomId: localStorage.getItem('random_id') || '64a60cf-8af4-1ec3-a2f-207721d6a22'
    }

    const token = getAccessToken();
    if (token) {
        headers['Authorization'] = `Bearer ${token}`
    }

    const config = {
        method: body ? 'POST' : 'GET',
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    }
    if (body) {
        config.body = JSON.stringify(body)
    }

    let data
    try {
        const response = await window.fetch(BASE_URL + endpoint, config)
        if (response.ok) {
            if (response.status === 204) {
                return {
                    status: response.status,
                    headers: response.headers,
                    url: response.url,
                }
            }
            data = await response.json()
            // Return a result object similar to Axios
            return {
                status: response.status,
                data: data?.data,
                headers: response.headers,
                url: response.url,
            }
        } else if (response.status === 401) {
            displayError('Un Authorized', customConfig?.shouldHide)
            window.localStorage.clear()
            window.location.href = '/'
        } else if (response.status === 403) {
            data = await response.json()
            displayError(data.message || data?.error?.message || 'Forbidden', customConfig?.shouldHide)
            return Promise.reject(data.message || data?.error?.message || 'Forbidden')
        } else if (response.status === 412) {
            data = await response.json()
            displayError(data.message || data?.error?.message || 'Invalid grand', customConfig?.shouldHide)
            return Promise.reject(data.message || data?.error?.message || 'Invalid grand')
        } else if (response.status === 400 || response.status === 404) {
            data = await response.json()
            let message = data.message
            if (data.errorDetails) {
                message = data.errorDetails
                    .map((e: any) => `${e.message || e.error}`)
                    .join(', ')
            }
            displayError(message || 'Forbidden', customConfig?.shouldHide)
            return Promise.reject(message)
        }

        displayError(
            response.statusText || 'Something went wrong',
            customConfig?.shouldHide
        )
        return Promise.reject(response.statusText)
    } catch (err: any) {
        return Promise.reject(err.message ? err.message : data)
    }
}

Client.get = function (endpoint: string, customConfig: any = {}) {
    let params: any = []
    if (customConfig.params) {
        for (let p in customConfig.params) {
            let key = p
            if (Array.isArray(customConfig.params[p])) {
                customConfig.params[p].forEach((element: any) => {
                    params.push(`${key}=${element}`)
                })
            } else {
                params.push(`${key}=${customConfig.params[p]}`)
            }
        }
    }
    if (customConfig.params) {
        return Client(endpoint + '?' + params.join('&'), {
            ...customConfig,
            method: 'GET',
        })
    } else {
        delete customConfig.params
        return Client(endpoint, {...customConfig, method: 'GET'})
    }
}

Client.post = function (endpoint: string, body: any, customConfig = {}) {
    return Client(endpoint, {...customConfig, body, method: 'POST'})
}

Client.put = function (endpoint: string, body: any, customConfig = {}) {
    return Client(endpoint, {...customConfig, body, method: 'PUT'})
}

Client.patch = function (endpoint: string, body: any, customConfig = {}) {
    return Client(endpoint, {...customConfig, body, method: 'PATCH'})
}

Client.delete = function (endpoint: string, customConfig = {}) {
    return Client(endpoint, {...customConfig, method: 'DELETE'})
}